import { NgModule} from '@angular/core';
import {CommonModule, DatePipe, TitleCasePipe} from '@angular/common';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { AlertModule} from './components/alert/alert.module';
import { LabelAlertModule } from './components/label-alert/label-alert.module';
import { TabsModule } from './components/tabs/tabs.module';
import { HeaderComponent } from './components/layout/header/header.component';
import { MonthDayOnlyPipe } from './pipes/month-day-only.pipe';
import { StatusTranslationPipe } from './pipes/status-translation.pipe';
import { GreetingPipe } from './pipes/greeting.pipe';
import { UserNamePipe } from './pipes/user-name.pipe';
import { SetFocusDirective } from './directives/setFocus/set-focus.directive';
import { NgbModalModule } from './components/modal/modal.module';
import { FooterComponent } from './components/layout/footer/footer.component';
import { OrderTypePipe } from './pipes/order-type/order-type.pipe';
import { NgbModule } from './components/modal/ngb.module';
import { GreatingTranslationPipe } from './pipes/greating-translation.pipe';
import {IdleService} from './services/idle/idle.service';
import {DebounceEventDirective} from './directives/debounce-event.directive';
import {TimeoutModule} from './modules/timeout/timeout.module';
import {RouterModule} from '@angular/router';
import { CvsDatePipe } from './pipes/cvs-date.pipe';
import { EditMedSwitchPipe } from './pipes/switches/edit-med-switch.pipe';
import {CopayModalModule} from '../dashboard/sync-plan/copay-modal/copay-modal.module';
import { SubmitOrderButtonPipe, SubmitOrderButtonDirective } from './directives/buttons/submit-order-button.directive';
import { ApprovalRequiredPipe} from './pipes/order-type/approval-required.pipe';
import { IsAutofillReviewPipe} from './pipes/order-type/autofill-order-review.pipe';
import {GetStripStartDatePipe} from './pipes/strip-start-date.pipe';
import { EligiblityCheck } from './pipes/eligiblity-check.pipe';

export const declaredComp = [
  SpinnerComponent,
  HeaderComponent,
  FooterComponent
];
export const declaredPipes = [
  MonthDayOnlyPipe,
  StatusTranslationPipe,
  GreetingPipe,
  UserNamePipe,
  EligiblityCheck,
  OrderTypePipe,
  GreatingTranslationPipe,
  CvsDatePipe,
  EditMedSwitchPipe,
  SubmitOrderButtonPipe,
  ApprovalRequiredPipe,
  IsAutofillReviewPipe,
  GetStripStartDatePipe
];
@NgModule({
  imports: [
    CommonModule,
    AlertModule,
    LabelAlertModule,
    TabsModule,
    NgbModule,
    TimeoutModule,
    CopayModalModule,
    RouterModule
  ],
  exports: [
    TabsModule,
    AlertModule,
    LabelAlertModule,
    NgbModule,
    TimeoutModule,
    SubmitOrderButtonDirective,
    ...declaredComp,
    ...declaredPipes
  ],
  declarations: [
    SetFocusDirective,
    DebounceEventDirective,
    SubmitOrderButtonDirective,
    ...declaredComp,
    ...declaredPipes
  ],
  providers: [IdleService, MonthDayOnlyPipe, TitleCasePipe, StatusTranslationPipe]
})
export class SharedModule {}
